module.exports = __webpack_public_path__ + "b152a3b6a98c143e07b5e8168f936f3c.svg";